import React from 'react';
import PropTypes from 'prop-types';
import VendorPaymentFilter from 'components/installation/siteFilterForm/VendorPaymentFilter';

import { Button } from 'react-bootstrap';

const VendorFilter = ({
  showFilter = false,
  filterToggle,
  applyFilter,
  
  siteFilters = false,
  
  listFilterData = null,
 
  
}) => {
  return (
    <div className={showFilter ? 'show-filter' : ''}>
      {showFilter && (
        <div className="filter-wrapper">
          <div className="filter-heading">
            <h4>Filters</h4>
            <Button onClick={filterToggle} className="close"></Button>
          </div>
          <div className="filter-body scrollbar-styling">
           

            {siteFilters && (
              <VendorPaymentFilter
              applyFilter={(val) => applyFilter(val)}
              
              siteStatus={
                listFilterData !== null ? listFilterData.vendor_portal_status : []
              }
            />
            )}

          </div>
        </div>
      )}
    </div>
  );
};

VendorFilter.propTypes = {
  showFilter: PropTypes.bool,
  filterToggle: PropTypes.func,
  applyFilter: PropTypes.func,
  getZones: PropTypes.func,
  getAreas: PropTypes.func,
  
};

export default VendorFilter;
